import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Box, Container, Grid, CircularProgress } from "@mui/material";
import "../../css/PaginaServicio/page.css"





export const ServiciosGrid = () => {
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [servicios, setServicios] = useState([]);
  const [producto, setProducto] = useState([]);


  const fetchSliders = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${backendURL}/api/all/public/servicio/home`);

      setServicios(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [ backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {

    fetchSliders();

  }, [fetchSliders]);


  const fetchProducto = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${backendURL}/api/telemetria/public`);

       setProducto(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [ backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {

    fetchProducto();

  }, [fetchProducto]);

  


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={80} thickness={6} />
        </Box>
      </div>
    );
  }
  return (
    <Container maxWidth="lg" sx={{ padding: "40px 0px" }}>

      {servicios.map((servicio, index) => (
        <Box key={index} sx={{ marginBottom: '50px' }}>
          <Grid container>
            <Grid size={{ xs: 12, sm: 6 }} >
              <Box sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                '@media (max-width:899px)': {
                  alignItems: 'center',
                  justifyContent: 'center',
                },
              }}>
                <Box sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  '@media (max-width:899px)': {
                    alignItems: 'center',
                    justifyContent: 'center',
                  },
                  '@media (max-width:280px)': {
                    flexDirection: 'column',
                    marginBottom: '20px'
                  },

                }}>
                  <h2 className="tituloserviciopage" >{servicio.titulo}</h2>
                  <h2 className="tituloserviciopage">{servicio.titulo1}</h2>

                </Box>
                <Box
                  sx={{
                    height: '5px', // grosor de la línea
                    width: '100px',
                    backgroundColor: servicio.color,
                    marginTop: '-10px',
                    borderRadius: '4px',

                  }}
                />
                <Box className="ImagenServicioPage" >
                  {servicio.icono && (
                    <img
                      src={`${backendURL}/${servicio.icono}`}
                      alt="HOD | Maquinas Dispensadoras"
                      title="HOD | Maquinas Dispensadoras"
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', '@media (max-width:899px)': {justifyContent:'flex-start'}, '@media (max-width:600px)': {justifyContent:'center'} }}>
              <Box sx={{
                position: 'relative',
                right: '15%',
                top: '10%',
                '@media (max-width:899px)': {
                  width: '80%',
                  right: '0%',
                },
                '@media (max-width:750px)': {
                  width: '100%'
                },
                '@media (max-width:600px)': {
                  width: '60%'
                },
                '@media (max-width:450px)': {
                  width: '90%'
                },
              }}>
                <Box sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-evenly',
                  marginBottom: '0px',
                }}>
                  <Box className="ImagenIconoServicioPage" sx={{
                     width:'100px',
                    padding: '20px 30px',
                     '@media (max-width:899px)': {
                       width:'100px',
                    padding: '20px',
                     }
                  }}>
                    {servicio.imagen_icono && (
                      <img
                        src={`${backendURL}/${servicio.imagen_icono}`}
                        alt="HOD | Maquinas Dispensadoras"
                        title="HOD | Maquinas Dispensadoras"
                      />
                    )}
                  </Box>
                  <Box>
                    <h4 className="descripcionpageservicio">
                      {servicio.descripcion}
                    </h4>
                  </Box>
                </Box>
                <Box sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-evenly'
                }}>
                  <Box className="ImagenIconoServicioPage" sx={{
                     width:'100px',
                    padding: '20px 30px',
                    '@media (max-width:899px)': {
                       width:'100px',
                    padding: '20px',
                     }
                  }}>
                    {servicio.imagen_icono2 && (
                      <img
                        src={`${backendURL}/${servicio.imagen_icono2}`}
                        alt="HOD | Maquinas Dispensadoras"
                        title="HOD | Maquinas Dispensadoras"
                      />
                    )}
                  </Box>
                  <Box>
                    <h4 className="descripcionpageservicio">
                      {servicio.descripcion1}
                    </h4>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>

        </Box>
      ))}
      <Box
        sx={{
          marginTop: '200px',
          '@media (max-width:899px)': {
            marginTop: '100px',
          },
          '@media (max-width:599px)': {
            marginTop: '200px',
          },
        }}>
        <Grid container >
          {producto.map((producto, index) => {
            const capacidades = [
              producto.capacidad,
              producto.capacidad1,
              producto.capacidad2,
              producto.capacidad3,
              producto.capacidad4,
              producto.capacidad5,
              producto.capacidad6,
              producto.capacidad7,
              producto.capacidad8,
            ].filter(Boolean);

            return (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} sx={{ padding: 2, marginBottom: '100px',display:'flex', justifyContent:'center' }}>
                <Box
                  sx={{

                    position: "relative",
                    borderRadius: "20px",
                    background: "#f0f0f0",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                     '@media (max-width:600px)': {
                       width:'70%',
                     },
                       '@media (max-width:450px)': {
                       width:'90%',
                 
                     }

                  }}
                >
                  {producto.imagen_producto && (
                    <Box className="imagenavatarprodcutotelimetria">
                      <img src={`${backendURL}/${producto.imagen_producto}`} alt="" />
                    </Box>
                  )}
                  <Box
                    sx={{
                      position: "relative",
                      marginTop: "70px",
                    }}
                  >

                    <Box sx={{ height: '40vh', padding: 2 }}>
                      <h2 className="titulotelemetriaservicio">{producto.titulo_maquina}</h2>
                      <ul style={{ listStyle: "none", paddingLeft: 0, textAlign: "justify", lineHeight: '25px' }}>
                        {capacidades.map((item, i) => (
                          <li className="descripciondetalladaservicio" key={i}>
                            <span style={{ color: producto.color || "#1A425B", marginRight: "6px" }}>
                              ▶
                            </span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>

    </Container>
  );
};